import { render, staticRenderFns } from "./PricingWidget.vue?vue&type=template&id=4d1ff8b6&"
import script from "./PricingWidget.vue?vue&type=script&lang=js&"
export * from "./PricingWidget.vue?vue&type=script&lang=js&"
import style0 from "./PricingWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports